import { useContext, useMemo } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useBreakpoint } from '@one-thd/sui-atomic-components';
import { windowExists } from '../components/Utils';
export var useIsMobile = function () {
    var _a = useContext(ExperienceContext), channel = _a.channel, isConsumerApp = _a.isConsumerApp;
    var isMobileFromChannel = channel === 'mobile';
    var isMobileFromNativeApp = isConsumerApp;
    var isMobileFromInnerWidth = windowExists() && (window === null || window === void 0 ? void 0 : window.innerWidth) < 640;
    var isMobileFromStencilHook = useBreakpoint('sm').lesser;
    var isMobile = isMobileFromChannel ||
        isMobileFromNativeApp ||
        isMobileFromStencilHook ||
        isMobileFromInnerWidth;
    return useMemo(function () { return ({ isMobile: isMobile, channel: channel, isConsumerApp: isConsumerApp }); }, [isMobile]);
};
export var useIsTablet = function () {
    var isBreakpointSM = useBreakpoint('sm').exact;
    var isBreakpointMD = useBreakpoint('md').exact;
    var isBreakpointLG = useBreakpoint('lg').exact;
    var isTabletFromStencilHook = isBreakpointSM || isBreakpointMD || isBreakpointLG;
    var isTablet = isTabletFromStencilHook;
    return useMemo(function () { return ({ isTablet: isTablet }); }, [isTablet]);
};
export var useIsDesktop = function () {
    var isDesktopFromStencilHook = useBreakpoint('lg').greater;
    var isDesktop = isDesktopFromStencilHook;
    return useMemo(function () { return ({ isDesktop: isDesktop }); }, [isDesktop]);
};
